import React, { Component } from "react";
import { connect } from "react-redux";
import { Dropdown, DropdownMenu, DropdownToggle } from "reactstrap";
import { LinkContainer } from "react-router-bootstrap";

import messages from "./Navigation.messages";
import LoopeLogo from "../../../../components/loope-logo/LoopeLogo";
import GradientButton from "../../../../components/input/GradientButton";
import ProjectModal from "../modals/project-modal/ProjectModal";

import { clearActiveProject } from "../../../../redux/projects/actions";
import { getProjects } from "../../../../redux/projects";
import { canAddProject, isMobile } from "../../../../helpers/Utils";

import type User from "../../../models/User";

type State = {
  userInfo: boolean,
  showNewProjectModal: boolean,
};

type OwnProps = {
  handleLogout: () => Promise<void>,
  shouldShowAddProjectButton: boolean,
  user: User,
};

type Props = OwnProps;

class Navigation extends Component {
  props: Props;
  state: State = {
    userInfo: false,
    showNewProjectModal: false,
  };

  clearActiveProjectPromise: ?Promise<void>;

  constructor(props: Props) {
    super(props);
  }

  onUserSelect = () => {
    this.setState({
      userInfo: !this.state.userInfo,
    });
  };

  openNewProjectModal = () => {
    this.setState({
      showNewProjectModal: true,
    });
  };

  closeNewProjectModal = () => {
    this.setState({
      showNewProjectModal: false,
    });
  };

  clearProjectAndAdd = async () => {
    await this.props.clearActiveProject();
    this.openNewProjectModal();
  };

  handleAddProject = () => {
    if (canAddProject(this.props.user, this.props.projects)) {
      this.clearActiveProjectPromise = Promise.resolve(
        this.clearProjectAndAdd()
      );
    } else {
      this.openSubscribeModal();
    }
  };

  renderNewProjectModal = () => (
    <ProjectModal
      onModalClose={this.closeNewProjectModal}
      user={this.props.user}
    />
  );

  render() {
    return (
      <div className="app-header">
        <div className="app-main-header">
          <div className="app-toolbar">
            <div className="app-logo-bl">
              <a href="/projects">
                <LoopeLogo fill="#222" width="120" height="60" />
              </a>
            </div>
            <ul className="header-notifications list-inline">
              <li className="list-inline-item user-nav">
                <Dropdown
                  id="basic-nav-dropdown"
                  className="quick-menu"
                  isOpen={this.state.userInfo}
                  toggle={this.onUserSelect.bind(this)}
                >
                  <DropdownToggle
                    className="d-inline-block"
                    tag="span"
                    data-toggle="dropdown"
                  >
                    <span className="icon-btn">
                      <a>{this.renderOwnerPhoto()}</a>
                    </span>
                  </DropdownToggle>
                  <DropdownMenu right>
                    <div className="user-profile">
                      {this.renderOwnerPhoto()}
                      <div className="user-detail ml-2">
                        <h4 className="user-name mb-0">
                          {this.props.user.firstName} {this.props.user.lastName}
                        </h4>
                        <small>{this.props.user.name}</small>
                      </div>
                    </div>
                    <LinkContainer
                      exact
                      to="/profile"
                      className="dropdown-item text-muted"
                    >
                      <a onClick={this.onUserSelect.bind(this)}>
                        {messages.profile}
                      </a>
                    </LinkContainer>
                    {!isMobile() && (
                      <LinkContainer
                        exact
                        to="/subscription"
                        className="dropdown-item text-muted"
                      >
                        <a onClick={this.onUserSelect.bind(this)}>
                          {messages.subscription}
                        </a>
                      </LinkContainer>
                    )}
                    <LinkContainer
                      exact
                      to="/"
                      onClick={this.props.handleLogout}
                      className="dropdown-item text-muted"
                    >
                      <a>{messages.logOut}</a>
                    </LinkContainer>
                  </DropdownMenu>
                </Dropdown>
              </li>
            </ul>
          </div>
          <div className="app-sub-toolbar">
            <GradientButton
              gradient="1/2"
              title={messages.projects}
              path="/projects"
            />
            {this.props.shouldShowAddProjectButton &&
              (canAddProject(this.props.user, this.props.projects) ? (
                <GradientButton
                  gradient="2/2"
                  title={messages.add_project}
                  handleClick={this.handleAddProject}
                />
              ) : (
                <div>Upgrade to add more events</div>
              ))}
          </div>
        </div>
        {!!this.state.showNewProjectModal && this.renderNewProjectModal()}
      </div>
    );
  }

  renderOwnerPhoto() {
    if (this.props.user.avatarURL) {
      return (
        <img
          className="user-avatar border-0 size-40"
          src={this.props.user.avatarURL}
          alt="User"
        />
      );
    } else {
      return (
        <i
          className="user-avatar border-0 size-40 fa fa-smile-o fa-3x"
          style={{ marginTop: 10 }}
        ></i>
      );
    }
  }
}

const mapStateToProps = (state) => ({
  projects: getProjects(state),
});

const mapActionsToProps = { clearActiveProject };

export default connect(mapStateToProps, mapActionsToProps)(Navigation);



// WEBPACK FOOTER //
// ./src/views/user/components/navigation/Navigation.js